export default {
  'Resize for': 'Yeniden boyutlandır',
  'Add 10 videos at most': 'En fazla 10 video ekleyin.',
}